export default {
  currentUser: {}, // TODO 18-03-21 Phil Lane: Determine if this should even be here
  suggestion: {},
  tickets: [],
  ownProblems: [],
  showAll:false,
  deadline:null
};
